import React, { useState, useEffect } from 'react';
// Lưu ý: Bạn cần thêm apiFetchNotificationHistory vào file api.js
import { apiFetchNotificationHistory } from '../../api';

const NotificationHistoryModal = ({ user, onClose }) => {
    const [history, setHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedNotification, setSelectedNotification] = useState(null);

    useEffect(() => {
        if (!user || !user.id) return;
        const fetchHistory = async () => {
            setIsLoading(true);
            try {
                const data = await apiFetchNotificationHistory(user.id);
                setHistory(data);
            } catch (error) {
                console.error("Lỗi tải lịch sử thông báo:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchHistory();
    }, [user]);

    // --- View chi tiết một thông báo ---
    if (selectedNotification) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4 animate-fade-in">
                <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl transform animate-fade-in-down">
                    <div className="p-5 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
                        <div>
                           <p className="text-sm font-semibold text-indigo-600">{selectedNotification.Sender}</p>
                           <h2 className="text-xl font-bold text-gray-800">{selectedNotification.Title}</h2>
                        </div>
                        <button onClick={() => setSelectedNotification(null)} className="text-gray-400 hover:text-gray-700 text-2xl" aria-label="Đóng chi tiết">&times;</button>
                    </div>
                    <div className="p-6 prose max-w-none max-h-[60vh] overflow-y-auto" dangerouslySetInnerHTML={{ __html: selectedNotification.Content }} />
                    <div className="p-4 bg-gray-50 text-right rounded-b-lg">
                         <button onClick={() => setSelectedNotification(null)} className="px-6 py-2 bg-indigo-600 text-white font-bold rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Đóng</button>
                    </div>
                </div>
            </div>
        );
    }

    // --- View danh sách lịch sử ---
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4 animate-fade-in">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col transform animate-fade-in-down">
                <div className="p-5 border-b flex justify-between items-center flex-shrink-0">
                    <h2 className="text-xl font-bold text-gray-800">Lịch sử thông báo</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-3xl font-light" aria-label="Đóng lịch sử">&times;</button>
                </div>
                <div className="p-4 sm:p-6 overflow-y-auto">
                    {isLoading ? <p className="text-center text-gray-500">Đang tải lịch sử...</p> : 
                     history.length === 0 ? <p className="text-center text-gray-500">Bạn chưa có thông báo nào.</p> :
                     <ul className="space-y-3">
                        {history.map(noti => (
                            <li 
                                key={noti.NotificationID} 
                                onClick={() => setSelectedNotification(noti)}
                                className={`p-4 border rounded-lg cursor-pointer transition-all duration-200 ease-in-out transform hover:-translate-y-1 hover:shadow-lg ${noti.IsRead ? 'bg-white' : 'bg-indigo-50 border-indigo-200'}`}
                            >
                                <div className="flex justify-between items-start gap-4">
                                    <div>
                                        <p className="text-xs text-gray-500">{noti.Sender} • {new Date(noti.CreatedAt).toLocaleDateString('vi-VN')}</p>
                                        <h3 className={`font-semibold mt-1 ${!noti.IsRead ? 'text-indigo-800' : 'text-gray-800'}`}>{noti.Title}</h3>
                                    </div>
                                    {!noti.IsRead && <span className="mt-1 w-2.5 h-2.5 bg-blue-500 rounded-full flex-shrink-0" title="Chưa đọc"></span>}
                                </div>
                            </li>
                        ))}
                     </ul>
                    }
                </div>
            </div>
        </div>
    );
};

export default NotificationHistoryModal;
